<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoEditar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoEditar">
            <form #f="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                    </div>
                </div>
                <div class="formgroup" *ngIf="profissional && !exibirSpinnerPrincipal">
                    <p-tabView styleClass="tabview-custom">
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <i class="pi pi-calendar mr-1"></i>
                                <span>Cadastro</span>
                            </ng-template>
                            <div class="p-fluid p-formgrid grid">
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="cpf">CPF</label>
                                    <p-inputMask
                                        mask="999.999.999-99"
                                        [unmask]="true"
                                        type="text"
                                        placeholder="000.000.000-00"
                                        name="cpf"
                                        ngModel
                                        #cpf="ngModel"
                                        [(ngModel)]="profissional.cpf"
                                        [readonly]="true"
                                    ></p-inputMask>
                                </div>
                                <div class="field col-12 md:col-7">
                                    <label htmlFor="nome">Nome Completo</label>
                                    <label class="form-control">
                                        {{ profissional.usuario?.nome }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label htmlFor="nomeProfissional">Apelido</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        name="nomeProfissional"
                                        type="text"
                                        pInputText
                                        ngModel
                                        #nomeProfissional="ngModel"
                                        [(ngModel)]="profissional.nomeProfissional"
                                    />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="funcao">Função</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        name="funcao"
                                        type="text"
                                        pInputText
                                        ngModel
                                        #funcao="ngModel"
                                        required
                                        [(ngModel)]="profissional.funcao"
                                    />
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="telefone">Telefone</label>
                                    <p-inputMask
                                        mask="(99) 99999-9999"
                                        [unmask]="true"
                                        type="text"
                                        placeholder="(99) 99999-9999"
                                        name="telefone"
                                        ngModel
                                        #telefone="ngModel"
                                        [(ngModel)]="profissional.telefone"
                                    ></p-inputMask>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label htmlFor="tipo">Tipo</label>
                                    <ng-container
                                        *ngIf="habilidades.length === 0; else mostrarLabelTipo"
                                    >
                                        <p-dropdown
                                            [options]="tipos"
                                            [filter]="true"
                                            optionLabel="label"
                                            optionValue="value"
                                            emptyFilterMessage="Nenhum registro"
                                            name="tipo"
                                            ngModel
                                            #tipo="ngModel"
                                            [(ngModel)]="profissional.tipo"
                                            (onChange)="recarregarContratos()"
                                        ></p-dropdown>
                                    </ng-container>
                                    <ng-template #mostrarLabelTipo>
                                        <label class="form-control" id="tipo">
                                            {{ profissional.tipo }}
                                        </label>
                                    </ng-template>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label for="contrato">Contrato</label>
                                    <ng-container
                                        *ngIf="habilidades.length === 0; else mostrarLabelContrato"
                                    >
                                        <p-dropdown
                                            [options]="contratos"
                                            optionLabel="razaoSocial"
                                            name="contrato"
                                            ngModel
                                            #contrato="ngModel"
                                            [(ngModel)]="profissional.contrato"
                                        ></p-dropdown>
                                    </ng-container>
                                    <ng-template #mostrarLabelContrato>
                                        <label class="form-control" id="tipo">
                                            {{ profissional.contrato?.razaoSocial }}
                                        </label>
                                    </ng-template>
                                </div>
                                <div class="field col-12 md:col-1">
                                    <label for="agenda">Agenda?</label>
                                    <br />
                                    <p-inputSwitch
                                        name="agenda"
                                        ngModel
                                        #agenda="ngModel"
                                        [(ngModel)]="profissional.agenda"
                                    ></p-inputSwitch>
                                </div>
                                <div class="field col-12 md:col-1">
                                    <label for="ativo">Ativo?</label>
                                    <br />
                                    <p-inputSwitch
                                        name="ativo"
                                        ngModel
                                        #ativo="ngModel"
                                        [(ngModel)]="profissional.ativo"
                                    ></p-inputSwitch>
                                </div>
                            </div>
                        </p-tabPanel>
                        <p-tabPanel header="habilidades">
                            <ng-template pTemplate="header">
                                <i class="pi pi-user mr-1"></i>
                                <span>Habilidades</span>
                            </ng-template>
                            <div class="p-fluid p-formgrid grid">
                                <div class="field col-12 md:col-2">
                                    <button
                                        pButton
                                        pRipple
                                        label="Adicionar"
                                        class="p-button-outlined mt-5"
                                        icon="pi pi-check"
                                        style="box-shadow: none"
                                        type="button"
                                        (click)="abrirDialogHabilidades()"
                                        [disabled]="exibirSpinnerHabilidades"
                                    ></button>
                                </div>
                            </div>
                            <div class="card mb-5">
                                <p-table
                                    #dt1
                                    [value]="habilidades"
                                    [rows]="10"
                                    [rowHover]="true"
                                    styleClass="p-datatable-gridlines"
                                    [paginator]="false"
                                    responsiveLayout="scroll"
                                    styleClass=" p-datatable-sm"
                                    [loading]="exibirSpinnerHabilidades"
                                    [globalFilterFields]="['itemServico.descricao', 'rateio', '']"
                                    [(selection)]="listaHabilidadesSelecionadas"
                                    selectionMode="multiple"
                                >
                                    <ng-template pTemplate="caption">
                                        <div
                                            class="flex justify-content-between flex-column sm:flex-row"
                                        >
                                            <div>
                                                <button
                                                    *ngIf="listaHabilidadesSelecionadas.length > 0"
                                                    pButton
                                                    type="button"
                                                    class="p-button-danger"
                                                    icon="pi pi-trash"
                                                    pTooltip="Excluir todas"
                                                    (click)="excluirTodasHabilidades()"
                                                    label="Excluir Selecionadas"
                                                ></button>
                                            </div>
                                            <div>
                                                <span class="p-input-icon-left">
                                                    <i class="pi pi-search"></i>
                                                    <input
                                                        pInputText
                                                        type="text"
                                                        #filter
                                                        (input)="buscar(dt1, $event)"
                                                        placeholder="Buscar"
                                                        class="w-full"
                                                    />
                                                </span>
                                                <span class="ml-2">
                                                    <button
                                                        pButton
                                                        class="p-button-outlined"
                                                        icon="pi pi-filter-slash"
                                                        pTooltip="Limpar Filtros"
                                                        (click)="limpar(dt1)"
                                                    ></button>
                                                </span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th style="width: 4rem">
                                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                            </th>
                                            <th>
                                                <div>Serviço</div>
                                            </th>
                                            <th>
                                                <div>Rateio</div>
                                            </th>
                                            <th>
                                                <div>Comissão</div>
                                            </th>
                                            <th>
                                                <div>Valor Fixo</div>
                                            </th>
                                            <th style="text-align: center">
                                                <div>Tempo (HH:mm)</div>
                                            </th>
                                            <th>
                                                <div>Agenda</div>
                                            </th>
                                            <th>
                                                <div>Excluir</div>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-item let-i="rowIndex">
                                        <tr>
                                            <td>
                                                <p-tableCheckbox
                                                    [value]="item"
                                                    inputId="{{ i }}"
                                                ></p-tableCheckbox>
                                            </td>
                                            <td>
                                                <label>{{ item.itemServico.descricao }}</label>
                                            </td>
                                            <td>
                                                <p-inputNumber
                                                    suffix="%"
                                                    name="rateio{{ i }}"
                                                    [max]="100"
                                                    [minFractionDigits]="1"
                                                    [maxFractionDigits]="2"
                                                    [(ngModel)]="item.rateio"
                                                    [disabled]="profissional.tipo === 'COLABORADOR'"
                                                ></p-inputNumber>
                                            </td>
                                            <td>
                                                <p-inputNumber
                                                    suffix="%"
                                                    name="comissao{{ i }}"
                                                    [max]="100"
                                                    [minFractionDigits]="1"
                                                    [maxFractionDigits]="2"
                                                    [(ngModel)]="item.comissao"
                                                    [disabled]="profissional.tipo === 'PARCEIRO'"
                                                    (ngModelChange)="alterarValorFixo(i)"
                                                ></p-inputNumber>
                                            </td>
                                            <td>
                                                <p-inputNumber
                                                    name="valorFixo{{ i }}"
                                                    ngModel
                                                    #valorFixo="ngModel"
                                                    [(ngModel)]="item.valorFixo"
                                                    mode="currency"
                                                    inputId="currency-brazil"
                                                    currency="BRL"
                                                    locale="pt-BR"
                                                    [allowEmpty]="false"
                                                    [disabled]="profissional.tipo === 'PARCEIRO'"
                                                    (ngModelChange)="alterarComissao(i)"
                                                ></p-inputNumber>
                                            </td>
                                            <td>
                                                <div class="flex w-10rem">
                                                    <select
                                                        class="form-control mr-1"
                                                        [(ngModel)]="item.tempoMedioHora"
                                                        name="hora{{ i }}"
                                                    >
                                                        <option
                                                            *ngFor="let hora of horasServico"
                                                            [value]="hora"
                                                        >
                                                            {{ hora }}
                                                        </option>
                                                    </select>

                                                    <select
                                                        class="form-control"
                                                        [(ngModel)]="item.tempoMedioMinuto"
                                                        name="minuto{{ i }}"
                                                    >
                                                        <option
                                                            *ngFor="let minuto of minutosServico"
                                                            [value]="minuto"
                                                        >
                                                            {{ minuto }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td>
                                                <label>{{ item.itemServico.agenda }}</label>
                                            </td>

                                            <td>
                                                <button
                                                    pButton
                                                    pRipple
                                                    pTooltip="Excluir"
                                                    type="button"
                                                    icon="pi pi-trash"
                                                    class="p-button-danger"
                                                    (click)="excluirHabilidade(item)"
                                                ></button>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="summary">
                                        <div
                                            class="flex align-items-center justify-content-between"
                                        >
                                            Há
                                            {{ habilidades ? habilidades.length : 0 }} habilidades
                                            cadastradas.
                                        </div>
                                    </ng-template>
                                </p-table>
                            </div>
                        </p-tabPanel>
                    </p-tabView>
                </div>
                <div
                    class="p-fluid p-formgrid grid justify-content-between"
                    *ngIf="!exibirSpinnerPrincipal"
                >
                    <div class="col-12 md:col-4">
                        <button
                            *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                            type="button"
                            pButton
                            icon="pi pi-check"
                            label="Atualizar"
                            (click)="atualizar()"
                            class="p-button-outlined p-button-success md:w-9rem"
                            [disabled]="!f.valid || !profissional"
                        ></button>
                        <ng-template #exibirBotaoFalso>
                            <button
                                type="submit"
                                pButton
                                icon="pi pi-spin pi-spinner"
                                label="Atualizar"
                                class="p-button-outlined p-button-success md:w-9rem"
                                disabled
                            ></button>
                        </ng-template>
                    </div>
                    <div class="col-12 md:col-4 flex justify-content-end">
                        <button
                            type="button"
                            pButton
                            icon="pi pi-arrow-left"
                            label="Voltar"
                            class="p-button-outlined md:w-9rem"
                            routerLink="/apps/profissional"
                        ></button>
                    </div>
                </div>
            </form>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
            <p-dialog
                header="Adicionar Habilidade"
                [(visible)]="exibirDialogServicos"
                [modal]="true"
                [style]="{ width: '50vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <div class="container col-12">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerDialog">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div
                        *ngIf="messagemVisivelDialog && !exibirSpinnerDialog"
                        class="field col-12 md:col-12"
                    >
                        <p-messages
                            [(value)]="messagemDialog"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <p-treeTable
                        #treeServicos
                        [value]="treeTableServicosDisponiveis"
                        [columns]="colunasTreeTableServicos"
                        selectionMode="checkbox"
                        [(selection)]="treeTableServicosDisponiveisSelecionado"
                        *ngIf="!exibirSpinnerDialog"
                    >
                        <ng-template pTemplate="caption">
                            <div class="flex justify-content-between flex-column sm:flex-row">
                                <div>
                                    <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                                    <span class="ml-2">Selecionar todas</span>
                                </div>
                                <div>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input
                                            pInputText
                                            class="w-full"
                                            type="text"
                                            #filter
                                            (input)="buscarTree(treeServicos, $event)"
                                            placeholder="Buscar"
                                        />
                                    </span>
                                    <span class="ml-2">
                                        <button
                                            pButton
                                            class="p-button-outlined"
                                            icon="pi pi-filter-slash"
                                            pTooltip="Limpar Filtros"
                                            (click)="limparTree(treeServicos)"
                                        ></button>
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns">
                                    {{ col.header }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template
                            pTemplate="body"
                            let-rowNode
                            let-rowData="rowData"
                            let-columns="columns"
                        >
                            <tr>
                                <td *ngFor="let col of columns; let i = index">
                                    <p-treeTableToggler
                                        [rowNode]="rowNode"
                                        *ngIf="i == 0"
                                    ></p-treeTableToggler>
                                    <p-treeTableCheckbox
                                        [value]="rowNode"
                                        *ngIf="i == 0"
                                    ></p-treeTableCheckbox>
                                    {{ rowData[col.field] }}
                                </td>
                            </tr>
                        </ng-template>
                    </p-treeTable>
                    <p-footer>
                        <button
                            type="button"
                            pButton
                            icon="pi pi-check"
                            label="Adicionar"
                            class="p-button-success mt-2"
                            (click)="adicionarHabilidadeDialog()"
                        ></button>
                    </p-footer>
                </div>
            </p-dialog>
        </div>
    </div>
</div>
